import React from 'react'
import PropTypes from 'prop-types'
import CloseIcon from 'assets/svgs/chevron.svg'
import * as S from './ProjectModal.styles'

const ProjectModal = ({ imgUrl, title, description, alt, show, handleClose }) => (
  <S.Wrapper show={show}>
    <S.CloseButton onClick={handleClose}>
      <CloseIcon />
    </S.CloseButton>
    <S.ImageWrapper>
      <img src={imgUrl} alt={alt} />
      <S.Text>
        <S.ProjectTitle><strong>Projeto:</strong> {title}</S.ProjectTitle>
        <S.ProjectDescription><strong>Responsáveis:</strong> {description}</S.ProjectDescription>
      </S.Text>
    </S.ImageWrapper>
  </S.Wrapper>
)

ProjectModal.propTypes = {
  imgUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  show: PropTypes.bool,
  handleClose: PropTypes.func.isRequired,
}

ProjectModal.defaultProps = {
  show: false,
}

export default ProjectModal
